import React, { useRef, useEffect, useState } from "react";
import { API_URL } from '../config';

const SliderHome = () => {
    const sectionRef = useRef(null);
    const elementRef = useRef(null);
    const elementRef2 = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const section = sectionRef.current;
            const element = elementRef.current;
            const element2 = elementRef2.current;
            if (!section || !element || !element2) return;

            const rect = section.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const sectionCenter = rect.top + rect.height / 2;
            const offset = sectionCenter - windowHeight / 2;

            const speed = 0.5;
            const translateX = offset * speed;

            element.style.transform = `translateX(${translateX}px)`;
            element2.style.transform = `translateX(${-translateX}px)`;
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const [clients, setClients] = useState([]);

    useEffect(() => {
        fetch(`${API_URL}/clients`)
            .then((res) => res.json())
            .then((data) => setClients(data.clients || []));
    }, []);

    const midpoint = Math.ceil(clients.length / 2);
    const firstRow = clients.slice(0, midpoint);
    const secondRow = clients.slice(midpoint);

    return (
        <>
            <div className="slider py-12" ref={sectionRef}>
                <h2 className="text-title-49 pl-12 mb-16 font-bold">
                    Nos clients<span>.</span>
                </h2>
                <div className="slider-left" ref={elementRef}>
                    <div className="mask">
                        {firstRow.map((client) => (
                            <div className="slide" key={client.id}>
                                {client.logo ? (
                                    <img src={`${client.logo}`} alt={client.name} />
                                ) : (
                                    <p>{client.name}</p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="slider-right mt-8" ref={elementRef2}>
                    <div className="mask">
                        {secondRow.map((client) => (
                            <div className="slide" key={client.id}>
                                {client.logo ? (
                                    <img src={`${client.logo}`} alt={client.name} />
                                ) : (
                                    <p>{client.name}</p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="slider-mobile py-12">
                <h2 className="text-title-49 pl-12 mb-16 font-bold">
                    Nos clients<span>.</span>
                </h2>
                <div className="slider-content">
                    {clients.slice(0, 8).map((client) => (
                        <div className="slide-m" key={client.id}>
                            {client.logo ? (
                                <img src={`${client.logo}`} alt={client.name} />
                            ) : (
                                <p>{client.name}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default SliderHome;